import { useCallback, useEffect, useState } from "react";
import { Scale } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import api from "@/lib/api";
import { LoginView } from "@/components/admin/LoginView";
import { AdminHeader } from "@/components/admin/AdminHeader";
import { ConsultationsPanel } from "@/components/admin/ConsultationsPanel";
import { ApplicationsPanel } from "@/components/admin/ApplicationsPanel";

const Admin = ({ section = "consulenze" }) => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* cookie already invalid */
    }
    setUser(null);
    toast.success("Logout effettuato");
  }, []);

  const expire = useCallback(() => {
    setUser(null);
    toast.error("Sessione scaduta", { description: "Effettua nuovamente l'accesso." });
  }, []);

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-navy">
        <Scale className="h-8 w-8 animate-pulse text-gold" />
      </div>
    );
  }
  if (!user) return <LoginView onSuccess={setUser} />;

  return (
    <div className="min-h-screen bg-pearl" data-testid="admin-dashboard">
      <AdminHeader user={user} section={section} onLogout={logout} />
      <main className="mx-auto max-w-7xl px-5 py-10 sm:px-8">
        {section === "candidature" ? <ApplicationsPanel onUnauthorized={expire} /> : <ConsultationsPanel onUnauthorized={expire} />}
      </main>
    </div>
  );
};

export default Admin;
